import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';
// @ts-expect-error
import type {RouterHistory} from 'react-router-dom';

import {Link} from 'shells/link/link';
import {ModalMain, RightFrame, NavButtons} from 'shells/modal/step-modal/layout';
import {ModalHeader} from 'shells/typography/modal-header';

import {
    RECOVERY_CODES_APP,
    RECOVERY_CODES_SMS,
    SELECT_METHOD,
    VERIFY_SMS_PHONE,
} from '../constants';
import {VerifyCodeScreen} from '../screens/verify-code-screen';
import type {Method} from '../types';

type Props = {
    history: RouterHistory;
    method: Method;
    phoneNumber: string;
};

export function VerifyCode(props: Props) {
    return (
        <RightFrame>
            <ModalMain>
                <ModalHeader>Verify Method</ModalHeader>
                <VerifyCodeScreen
                    goNext={() => {
                        props.history.push(
                            props.method === 'app' ? RECOVERY_CODES_APP : RECOVERY_CODES_SMS
                        );
                    }}
                    goBack={() => {
                        props.history.push(VERIFY_SMS_PHONE);
                    }}
                    method={props.method}
                    phoneNumber={props.phoneNumber}
                />
            </ModalMain>

            <NavButtons style={{justifyContent: 'flex-start'}}>
                <React.Fragment>
                    <Link
                        variant='primary'
                        size='big'
                        // @ts-expect-error
                        as={RoutedLink}
                        to={props.method === 'app' ? SELECT_METHOD : VERIFY_SMS_PHONE}
                    >
                        Back
                    </Link>
                </React.Fragment>
            </NavButtons>
        </RightFrame>
    );
}
